module.exports = __webpack_public_path__ + "static/media/mosk-light-300-webfont.104f2e56.woff";